"use client";

import { getPayloadUrlForClientRequests } from "@/app/_api/payloadClient";
import { RefreshRouteOnSave as PayloadRefreshRouteOnSave } from "@payloadcms/live-preview-react";
import { useRouter } from "next/navigation";

export function RefreshRouteOnSave() {
  const router = useRouter();
  return <PayloadRefreshRouteOnSave refresh={router.refresh} serverURL={getPayloadUrlForClientRequests()} />;
}

RefreshRouteOnSave.displayName = "RefreshRouteOnSave";
